// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.container[data-v-92c5d598] {\n  padding: 10px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.searchBox[data-v-92c5d598] .selectClass .el-input__inner {\n  font-weight: 600 !important;\n}\n.table_color_class[data-v-92c5d598] .WaybillNumber {\n  color: #606266 !important;\n}\n", ""]);
// Exports
module.exports = exports;
